module.exports = __webpack_public_path__ + "img/408.e9b27dfe.jpg";